import { render, staticRenderFns } from "./take_air.vue?vue&type=template&id=89b69b34&"
import script from "./take_air.vue?vue&type=script&lang=js&"
export * from "./take_air.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports